import React from 'react';
import { Link } from 'react-router-dom'; // React RouterのLinkを使用
import Footer from '../components/Footer';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import Header from '../components/Header';

const ResetPasswordCompleted = () => {
    const { vendorInfo } = useSelector((state: RootState) => state.vendor);
    return (
        <div>


            {/* メインコンテンツ */}
            <section className="section-login main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-sm-10 mx-auto">
                            <div className="login-wrapper bg-white rounded-50 theme-box-shadow-2 p-lg-5 p-4 text-center">
                                <div className="p-lg-4">
                                    <img
                                        className="img img-fluid img-success mb-3"
                                        src="assets/images/registration/success-icon.svg"
                                        alt="Success"
                                    />
                                    <div className="text-red-03 text-custom-xl-1 fw-400 mb-lg-5 mb-4">SUCCESS</div>
                                    <div className="text-sm mb-lg-5 mb-4 fw-400">パスワードを変更しました。
                                        <br />
                                        ログインしてご利用ください。</div>
                                    {/* リンクボタン */}
                                    {/* <Link to="/bidding"> */}
                                    <Link to="/">

                                        <button type="button" className="btn btn-theme btn-danger rounded-pill px-lg-5 mb-5">
                                            <span className="px-lg-5 px-4">ログイン</span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </section >

            {/* フッター部分 */}
            <Footer />
        </div >
    );
};

export default ResetPasswordCompleted;
